module.exports = __webpack_public_path__ + "images/159_2048.jpg";